import {
  Box,
  Button,
  ButtonProps,
  Container,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  Paper,
  styled,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Breadcrumb from "../../../Shared-ui/SharedComponents/Breadcrumb";
import variables from "../../../assets/styles/variables.module.scss";
import AddIcon from "@mui/icons-material/Add";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import CloseIcon from "@mui/icons-material/Close";
import PermissionsTable from "./permissionsTable";
import { Role } from "../../../Shared-ui/Types/common";
import { DefaultPermission } from "../../../Constant/Setting";
import { isOnlyAlphabetsNumbers } from "../../../Shared-ui/utils/Common/Common";
import { useDispatch } from "react-redux";
import { StartLoading, StopLoading } from "../../../Shared-ui/Store/LoadingReducer/LoaderActions";
import { ShowError, ShowSuccess } from "../../../Shared-ui/Store/MessageReducer/MsgActions";
import MetaInstance from "../../../Services/AxiosInstance/MetaInstance";
import { CREATE_ROLE, DELETE_ROLE, GET_ROLE, UPDATE_ROLE } from "../../../Services/Endpoint";
import Confirm from "../../../Shared-ui/Types/Confirm";
import ConfirmPopup from "../../../Shared-ui/SharedComponents/ConfirmPopup";

const ColorButton = styled(Button)<ButtonProps>(({ theme }) => ({
  // borderRadius: "8px",
  color: variables.whiteColor,
  backgroundColor: variables.primaryButton,
  "&:hover": {
    backgroundColor: variables.primaryColor,
  },
}));





const AdminRoles = () => {
  const roleInitial: Role = {
    name: "",
    permissions: DefaultPermission
  }
  const roleErrInitial = {
    name: { error: "", value: false },
    permissions: { error: "", value: false },
  }

  const theme = useTheme();
  const dispatch = useDispatch();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [expanded, setExpanded] = useState<boolean>(false); // Track expanded panel
  const [role, setRole] = useState<Role>(roleInitial)
  const [roles, setRoles] = useState<Role[]>([])
  const [rolesCount, setRolesCount] = useState<number>(0)
  const [roleErr, setRoleErr] = useState(roleErrInitial)
  const [isEditing, setIsEditing] = useState(false)
  const [pagination, setPagination] = useState({ page: 0, pageSize: 10 });
  const [confirmPopupData, setConfirmPopupData] = useState<Confirm>({ show: false })




  useEffect(() => {
    getRoles()

  }, [pagination])

  const getRoles = async () => {
    try {
      dispatch(StartLoading())
      const data = await MetaInstance.get(`${GET_ROLE}?page=${pagination.page}&limit=${pagination.pageSize}&sort=createdAt`).then(res => res?.data?.detail)
      setRoles(data.response)
      setRolesCount(data.count)
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response));
    } finally {
      dispatch(StopLoading())
    }
  }

  const CreateRole = async () => {
    if (!validateRole()) return
    try {
      dispatch(StartLoading())
      const data = await MetaInstance.post(`${CREATE_ROLE}`, role).then(res => res?.data?.detail)
      dispatch(ShowSuccess(data?.response));
      handleCancel()
      getRoles()
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response));
    } finally {
      dispatch(StopLoading())

    }

  }
  const updateRole = async () => {
    if (!validateRole()) return
    try {
      dispatch(StartLoading())
      const data = await MetaInstance.put(`${UPDATE_ROLE}`, role).then(res => res?.data?.detail)
      dispatch(ShowSuccess(data?.response));
      handleCancel()
      getRoles()
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response));
    } finally {
      dispatch(StopLoading())

    }
  }

  const deleteRole = async (role: Role) => {
    try {
      setConfirmPopupData((preVal) => ({ ...preVal, show: false }));
      dispatch(StartLoading())
      const data = await MetaInstance.delete(`${DELETE_ROLE}?name=${role.name}`).then(res => res?.data?.detail)
      dispatch(ShowSuccess(data.response))
      getRoles()
    } catch (err: any) {
      dispatch(ShowError(err?.response?.data?.detail?.response))
    } finally {
      dispatch(StopLoading())

    }
  };

  const confirmDelete = (row: Role) => {
    setConfirmPopupData({
      show: true,
      setConfirmPopupData: setConfirmPopupData,
      title: "Confirm Delete",
      info: "Are you sure want to delete your data? This action cannot be undone.",
      varient: "delete",
      functionName: deleteRole,
      functionParam: row
    })
  }

  const editRole = (role: Role) => {
    setRole(role)
    setIsEditing(true)
    setExpanded(true)
  }
  const validateRole = () => {
    if (!role.name) {
      setRoleErr((preVal) => ({
        ...preVal,
        name: { error: "Enter The Name", value: true },
      }));
      return false;
    } else if (!isOnlyAlphabetsNumbers(role.name)) {
      setRoleErr((preVal) => ({
        ...preVal,
        name: { error: "Special Character Not Allowed", value: true },
      }));
      return false;
    } else {
      setRoleErr((preVal) => ({
        ...preVal,
        name: { error: "", value: false },
      }));
    }

    if (!Object.values(role.permissions).some(val => val !== false)) {
      setRoleErr((preVal) => ({
        ...preVal,
        permissions: { error: "please select role", value: true },
      }));
      return false;
    } else {
      setRoleErr((preVal) => ({
        ...preVal,
        permissions: { error: "", value: false },
      }));
    }
    return true
  }
  const changePermission = (event: React.ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name as keyof Permissions
    const checked = event.target.checked
    setRole((preVal: Role) => {
      const permission = { ...preVal.permissions, [name]: checked };
      return { ...preVal, permissions: permission };
    })
    setRoleErr((preVal) => ({
      ...preVal,
      permissions: { error: "", value: false },
    }));
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    setRole((preVal: Role) => ({ ...preVal, [name]: value }))
  }


  const handleCancel = () => {
    setExpanded(false); // Reset expanded state
    setRole(roleInitial)
    setIsEditing(false)

  };

  const handlePaginationMetaChange = (paginationMeta: any) => {
    const { page, pageSize, rowCount } = paginationMeta;
    setPagination({ page: page + 1, pageSize: pageSize })
  };

  const columns: GridColDef[] = [
    { field: "name", headerName: "Role Name", width: 280 },
    { field: "createdAt", headerName: "Created Date", width: 350 },
    { field: "updatedAt", headerName: "Updated Date", width: 350 },
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      renderCell: (params) => {
        return (
          <Box>
            <IconButton aria-label="edit" onClick={() => editRole(params.row)}>
              <EditOutlinedIcon />
            </IconButton>
            <IconButton aria-label="delete" onClick={() => confirmDelete(params.row)}>
              <DeleteOutlineOutlinedIcon />
            </IconButton>
          </Box>
        );
      },
    },
  ];



  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          //pb: 3,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: { md: "flex-end", sm: "flex-start" },
            gap: { md: "10px", sm: "0" },
            flexDirection: { md: "row", sm: "column", xs: "column" },
          }}
        >
          <Breadcrumb data={[{ name: "Roles", path: "" }]} />
        </Box>
        <Box>
          <ColorButton
            variant="contained"
            disableElevation
            startIcon={<AddIcon />}
            size={isSmallScreen ? "small" : "large"}
            sx={{
              textTransform: "capitalize",
              fontWeight: "400",
              whiteSpace: "nowrap",
              borderRadius: { sm: "8px", xs: "4px" },
              height: "40px",
            }}
            onClick={() => setExpanded(true)}
          >
            Create Role
          </ColorButton>
        </Box>
      </Box>
      <Paper sx={{ height: 400, width: "100%", }} elevation={0}>
        <DataGrid
          rows={roles}
          columns={columns}
          rowCount={rolesCount}
          initialState={{ pagination: { paginationModel: pagination } }}
          pageSizeOptions={[10]}
          getRowId={(row) => row.name}
          onPaginationModelChange={handlePaginationMetaChange} // Handle pagination meta change
          paginationMode="server"
          sx={{
            border: 1,
            borderColor: variables.borderColor,
            "& .MuiDataGrid-cell:focus": {
              outline: "none",
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none",
            },
          }}
        />
      </Paper>
      {expanded && (
        <Box
          sx={{
            "&::before": {
              content: '""',
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 7,
            },
          }}
        >
          <Box
            sx={{
              width: "500px",
              display: "flex",
              flexDirection: "column",
              gap: 3,
              pt: "10px",
              position: "fixed",
              right: "0",
              top: "0",
              height: "100vh",
              background: variables.whiteColor,
              padding: "20px 30px",
              zIndex: 8,
            }}
          >
            <Box
              sx={{
                position: "relative",
                height: "100%",
              }}
            >
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Typography variant="h6" gutterBottom>
                    Create New Role
                  </Typography>
                  <IconButton aria-label="close" onClick={handleCancel}>
                    <CloseIcon />
                  </IconButton>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    mt: 2,
                    pt: "5px",
                    height: "calc(100vh - 160px)",
                    overflow: "auto",
                  }}
                >
                  <FormControl fullWidth variant="outlined" required error={roleErr.name.value}>
                    <InputLabel
                      htmlFor="name"
                      shrink
                      sx={{ background: "#fff", px: 0.5 }}
                    >
                      Role Name
                    </InputLabel>
                    <TextField
                      //size="small"
                      id="name"
                      name="name"
                      value={role.name}
                      error={roleErr.name.value}
                      helperText={roleErr.name.error}
                      onChange={handleChange}
                      placeholder="Enter role"
                      sx={{ background: "white" }}
                    />
                  </FormControl>
                  <Typography sx={{ fontWeight: "bold" }}>Permissions</Typography>
                  {/* permission table */}
                  <PermissionsTable changePermission={changePermission} data={role} />
                  {roleErr.permissions.value && <FormHelperText error={roleErr.permissions.value}> {roleErr.permissions.error}</FormHelperText>}

                </Box>
              </Box>
              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  gap: 2,
                  justifyContent: "flex-end",
                  position: "absolute",
                  bottom: 0,
                }}
              >
                <Button
                  fullWidth
                  variant="outlined"
                  disableElevation
                  size="large"
                  sx={{
                    textTransform: "capitalize",
                  }}
                  onClick={handleCancel} // Call handleCancel on click
                >
                  Cancel
                </Button>
                {!isEditing ?
                  <Button
                    fullWidth
                    variant="contained"
                    disableElevation
                    size="large"
                    sx={{
                      textTransform: "capitalize",
                    }}
                    onClick={CreateRole}
                  >
                    Save
                  </Button>
                  :
                  <Button
                    fullWidth
                    variant="contained"
                    disableElevation
                    size="large"
                    sx={{
                      textTransform: "capitalize",
                    }}
                    onClick={updateRole}
                  >
                    Save
                  </Button>
                }
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      <ConfirmPopup details={confirmPopupData} />

    </Container>
  );
};

export default AdminRoles;
